export default __webpack_public_path__ + "static/media/txt_entrance_10.ec6f4e12.svg";